var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c("b-col", [
        _c(
          "div",
          { staticClass: "overflow-y-auto", staticStyle: { height: "480px" } },
          [
            _c(
              "div",
              { staticClass: "filogix-details-list px-4 position-relative" },
              [
                !_vm.filogixSubmissions.length
                  ? _c(
                      "no-results",
                      {
                        staticClass: "py-4",
                        attrs: {
                          "img-src": require("@Shared/@Assets/img/application-missing.png"),
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("filogix.thereAreNoDealsSubmittedYet")
                            ) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._l(_vm.filogixSubmissions, function (submission) {
                      return _c("deal-row", {
                        key: submission.filogixSubmissionId,
                        attrs: {
                          submission: submission,
                          lenders: _vm.lenders,
                          "client-username": _vm.clientUsername,
                          "application-id": _vm.applicationId,
                          "agent-username": _vm.agentUsername,
                          "disable-sync": !_vm.validFilogixDetails,
                          "sync-progress":
                            _vm.syncProgress[submission.filogixSubmissionId],
                          "has-incident": _vm.hasIncident,
                        },
                        on: { sync: _vm.handleSyncWithFilogix },
                      })
                    }),
              ],
              2
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }